import { IBadgesMessages } from 'types/BadgeTypes';

export const notificationMessage: IBadgesMessages = {
  creative: 'badgeModal.badge.title.creative',
  debugger: 'badgeModal.badge.title.debugger',
  lightning: 'badgeModal.badge.title.lightning',
  perfect: 'badgeModal.badge.title.perfect',
};
